export const formatPrice = (price) => {
  if (price == null || isNaN(price)) {
    return "0.00";
  }
  return parseFloat(price)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
